import { render } from "./ClientCourses.vue?vue&type=template&id=eb2b88fa"
import script from "./ClientCourses.vue?vue&type=script&lang=js"
export * from "./ClientCourses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__